






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class File extends Vue {
    @Prop()
    private articleId !: number;

    private loading = false;

    private pagedData = [];
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getFiles(this.articleId)
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(name: number) {
        this.$confirm('此操作将删除选中的附件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            var ids = name == null ? this.multipleSelection.map(item => item.name) : [name];
            this.$apis.delFiles(this.articleId, { data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 预览
    onView(url: string) {
        window.open(this.$store.state.filePreviewURL + 'onlinePreview?url=' + encodeURIComponent(this.base64_encode(this.$store.state.fileURL + url))); 
    }

    // 字符串转uint字节数组
    // 由于字符串中可能包含utf8不定长度字节的编码
    private str2bytes(str: string): Array<any> {
        let bytes = new Array();
        let len, c;
        len = str.length;
        for (let i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if (c >= 0x010000 && c <= 0x10FFFF) {
                bytes.push(((c >> 18) & 0x07) | 0xF0);
                bytes.push(((c >> 12) & 0x3F) | 0x80);
                bytes.push(((c >> 6) & 0x3F) | 0x80);
                bytes.push((c & 0x3F) | 0x80);
            } else if (c >= 0x000800 && c <= 0x00FFFF) {
                bytes.push(((c >> 12) & 0x0F) | 0xE0);
                bytes.push(((c >> 6) & 0x3F) | 0x80);
                bytes.push((c & 0x3F) | 0x80);
            } else if (c >= 0x000080 && c <= 0x0007FF) {
                bytes.push(((c >> 6) & 0x1F) | 0xC0);
                bytes.push((c & 0x3F) | 0x80);
            } else {
                bytes.push(c & 0xFF);
            }
        }
        return bytes;
    }

    // base64 编码
    private base64_encode(input: string): string {
        const _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        let data = this.str2bytes(input);

        while (i < data.length) {
            chr1 = data[i++];
            chr2 = data[i++];
            chr3 = data[i++];

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }

        return output;
    }

    // 拦截上传
    uploadFile(params: any) {

        // 可以在上传之前就行文件类型和大小处理
        var formData = new FormData();
        if (params != null)
            formData.append('files', params.file);

        this.editFormVisible = false;
        
        // 新增
        this.$apis.postFile(this.articleId, formData)
            .then((res: any) => {
                this.reload(); // 刷新列表
                
                (this.$refs.upload as any).clearFiles();
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
            });
    }
}
